import { helpers } from "../../common/lib";
import getInitialState from "../get-initial-state";
import { actionTypes } from "./actions";

export default function (state = getInitialState.list(), action) {
    switch (action.type) {
        case actionTypes.AUDIT_ASSIGNMENTS_BULK_UPDATE_POST_SUCCESS:
        case actionTypes.AUDIT_ASSIGNMENTS_POST_SUCCESS: {
            const { auditAssignments } = action.payload;
            return helpers.mergeListReducer(state, auditAssignments);
        }
        case actionTypes.AUDIT_ASSIGNMENTS_PATCH_SUCCESS: {
            const { data } = action.payload;
            return helpers.mergeListReducer(state, [data]);
        }
        case actionTypes.AUDIT_ASSIGNMENTS_CLEAR: {
            return getInitialState.list();
        }
        case actionTypes.AUDIT_ASSIGNMENTS_SET: {
            const { auditAssignments } = action.payload;
            return helpers.getListReducer(state, auditAssignments);
        }
        default: {
            return state;
        }
    }
}
